import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class DeviceGroupsService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
		this._rc = new RealtimeClient();
	}

	/**
	 * Get all device groups
	 * @param {function} callback
	 */
	getAll(callback) {
		const url = `/ecosystem/api/deviceGroups`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Get device group by id
	 * @param {function} callback
	 */
	getById(deviceGroupId, callback) {
		const url = `/ecosystem/api/deviceGroups/${deviceGroupId}`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Create a device group
	 * @param {Object} data
	 */
	create(data, callback) {
		const url = `/ecosystem/api/deviceGroups`;
		const body = JSON.stringify(data);
		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Update a device group
	 * @param {String} deviceGroupId
	 */
	update(deviceGroupId, data, callback) {
		const url = `/ecosystem/api/deviceGroups/${deviceGroupId}`;
		const body = JSON.stringify(data);
		this._restClient.exec_put(url, body, callback);
	}

	/**
	 * delete a device group
	 * @param {String} deviceGroupId
	 */
	deleteDeviceGroup(deviceGroupId, callback) {
		const url = `/ecosystem/api/deviceGroups/${deviceGroupId}`;
		this._restClient.exec_delete(url, callback);
	}

	/**
	 * Add devices to a device group
	 * @param {String} deviceGroupId
	 */
	addDevices(deviceGroupId, data, callback) {
		const url = `/ecosystem/api/deviceGroups/${deviceGroupId}/addDevices`;
		const body = JSON.stringify(data);
		this._restClient.exec_put(url, body, callback);
	}

	/**
	 * Remove devices from a device group
	 * @param {String} deviceGroupId
	 */
	removeDevices(deviceGroupId, data, callback) {
		const url = `/ecosystem/api/deviceGroups/${deviceGroupId}/removeDevices`;
		const body = JSON.stringify(data);
		this._restClient.exec_put(url, body, callback);
	}

	/**
	 * Move a device group
	 * @param {String} deviceGroupId
	 * @param {String} parentDeviceGroupId
	 */
	moveDeviceGroup(deviceGroupId, parentDeviceGroupId, callback) {
		const url = `/ecosystem/api/deviceGroups/${deviceGroupId}/move/${parentDeviceGroupId}`;
		this._restClient.exec_put(url, callback);
	}

	subscribeDeviceGroups(callback) {
		this._rc.subscribe("ecosystem", "/deviceGroups", {}, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				callback(null, response);
			}
		});
	}
}
